// Definição para o modal de busca de Moedas
// Factory function - recebe filtros como parâmetros, sem magic strings

import { ST } from '@/constants/ST'

export const criarConfigBuscaMoeda = (lstStatus = ST.Ativo) => ({
  label: 'Moeda',
  placeholder: 'Código ISO ou Nome...',
  titulo: 'Selecionar Moeda',
  endpointApi: 'Moedas',
  endpointFetchPorCodigo: 'Moedas/iso',
  idField: 'idMoeda',
  displayField: 'idMoeda',
  descField: 'nome',
  camposFiltro: [
    { label: 'Código ISO ou Nome', model: 'busca', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'Código ISO', dataField: 'codigoISO', width: '20%' },
    { header: 'Moeda', dataField: 'nome', width: '80%' }
  ],
  filtrosFixos: {
    lstStatus
  }
})
